import { Link } from 'react-router-dom';
import type { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';

import { ROUTE_PLAN_BY_ID, ROUTE_KNM_LIST_WITH_PLAN } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IconExport } from 'UIPackage/IconsModule/components/IconExport';
import { Dropdown } from 'UIPackage/MainModule/components/Dropdown';
import { DropdownItem } from 'UIPackage/MainModule/components/DropdownItem';
import { IDropdownItem } from 'UIPackage/MainModule/interfaces/IDropdownItem';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { planListExportPlanById } from 'PlanListPackage/MainModule/actions/planListActions';

import styles from './KnmListTable.module.scss';
import { IKnmRaw } from '../interfaces/IKnmRaw';

export const KnmListPlanIdCell = ({ value, row, isErknm, isOmbudsman }: ITableRenderCell<IKnmRaw>) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const currentValue = typeof value === 'number' || typeof value === 'string' ? value : '';

  const handleExport = (format: ExportFormatsEnum, id: string, approved: boolean) => () => {
    dispatch(planListExportPlanById(format, Number(id), approved));
  };

  const renderExportDropdown = (id: string) => {
    const dropdownItems: IDropdownItem[] = [
      {
        id: 'export-ods',
        content: (
          <DropdownItem onClick={handleExport(ExportFormatsEnum.ODS, id, false)}>Экспорт плана в ODS</DropdownItem>
        ),
      },
      {
        id: 'export-xlsx',
        content: (
          <DropdownItem onClick={handleExport(ExportFormatsEnum.XLSX, id, false)}>Экспорт плана в XLSX</DropdownItem>
        ),
      },
      {
        id: 'divider-1',
        isDivider: true,
      },
      {
        id: 'export-agreed-ods',
        content: (
          <DropdownItem onClick={handleExport(ExportFormatsEnum.ODS, id, true)}>
            Экспорт согласованного плана в ODS
          </DropdownItem>
        ),
      },
      {
        id: 'export-agreed-xlsx',
        content: (
          <DropdownItem onClick={handleExport(ExportFormatsEnum.XLSX, id, true)}>
            Экспорт согласованного плана в XLSX
          </DropdownItem>
        ),
      },
    ];

    return (
      <Dropdown items={dropdownItems}>
        <button className={styles.ExportMenuButton} type="button">
          <IconExport className={styles.ExportMenuIcon} />
        </button>
      </Dropdown>
    );
  };

  const planId: number | undefined = Object.entries(row).find(item => item[0] === 'planId')?.[1];

  return (
    <div className={styles.Container}>
      <Link
        className="shared-table-link"
        to={
          isErknm
            ? ROUTE_PLAN_BY_ID(currentValue, `backUrl=${encodeURI(window.location.pathname)}`)
            : ROUTE_KNM_LIST_WITH_PLAN(currentValue)
        }
        target={isErknm ? '' : '_blank'}
      >
        {currentValue}
      </Link>
      {currentValue && !isOmbudsman && renderExportDropdown(String(planId))}
    </div>
  );
};
